import _ from 'lodash';
import { STORYZ_LINK } from '../../constants/ActionTypes';

const initialState = {
  error: null,
  loaded: false,
  loading: false,
  result: {},
};

/**
 * StoryZLink Reducer
 * @param {*} state
 * @param {*} action
 */
export default function storyZLink(state = initialState, action = {}) {
  switch (action.type) {
    case `${STORYZ_LINK}_PENDING`:
      return {
        ...state,
        error: null, // state.error = null
        loaded: false, // state.loaded = false
        loading: true, // state.loading = true
      };
    case `${STORYZ_LINK}_SUCCESS`:
      return {
        ...state,
        error: null,
        result: action?.result,
        loaded: true,
        loading: false,
      };
    case `${STORYZ_LINK}_FAIL`:
      return {
        ...state,
        error: action.error,
        loaded: false,
        loading: false,
      };
    default:
      return state;
  }
}
